import React from 'react';
import './Search.css';
import VehicleTypeNav from '../components/VehicleTypeNav';
import { useState } from 'react'; // Import useState for CarCard
import { useLocation } from 'react-router-dom';

const CarCard = ({ car }) => {
    const defaultImage = process.env.PUBLIC_URL + '/images/shake-hand-buy-car.jpg';
    const [isFlipped, setIsFlipped] = useState(false);

    // Error handling for image loading
    const handleError = (e) => {
        e.target.src = defaultImage;
    };

    // Toggle the flipped state on card click
    const handleCardClick = () => {
        setIsFlipped(!isFlipped);
    };

    // Format the price to include commas
    const formatCurrency = (number) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(number);
        
    };

    return (
        <div className={`car-card ${isFlipped ? 'flipped' : ''}`} onClick={handleCardClick}>
            <div className="car-card-inner">
                <div className="car-card-front">
                    <div className="car-image">
                        <img
                            src={car.imagesURL || defaultImage}
                            alt={`${car.make} - ${car.model} - ${car.yearOfManufacture}`}
                            onError={handleError}
                        />
                    </div>
                    <div className="car-info">
                        <h3>{car.make} - {car.model} ({car.yearOfManufacture})</h3>
                        <div className="car-details">
                            <span>MPG: {car.mpg}</span>
                            <span>Price: {formatCurrency(car.price)}</span> 
                        </div>
                    </div>
                </div>
                <div className="car-card-back">
                    <div className="car-info">
                        <img src='/images/cw.jpg' alt='cw' className="car-info-image" />
                        <h3>CarWiz</h3>
                        <p>Recalls: {car.recalls}</p>
                        <p>Safety Rating: {car.safetyRating}</p>
                        <p>Seating Capacity: {car.seatingCapacity}</p>
                        <p>Cost to Drive: {formatCurrency(car.costToDrive)}</p>
                        <p>Transmisson: {car.transmissionType}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const UserResults = () => {
    const location = useLocation();
    const userCars = location.state?.cars || []; 
    return (
        <div className="search-container">
            <VehicleTypeNav />
            <div className="cars-container">
                {userCars.length > 0 ? (
                    userCars.map(car => <CarCard key={car.CarID} car={car} />)
                ) : (
                    <p>Sorry, no cars found based on your criteria. We're working on expanding our database. Please check back soon.</p>
                )}
            </div>
        </div>
    );

};

export default UserResults;